import { render, staticRenderFns } from "./zonadiversion.vue?vue&type=template&id=0dfb1468"
import script from "./zonadiversion.vue?vue&type=script&lang=js"
export * from "./zonadiversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports